/*
 * AssessmentRubric Messages
 *
 * This contains all the text for the AssessmentRubric component.
 */
import { defineMessages } from "react-intl";

export default defineMessages({
  questionHeader: {
    id: "app.components.AssessmentRubric.questionHeader",
    defaultMessage: "Objectives",
  },
  alternative1: {
    id: "app.components.AssessmentRubric.alternative1",
    defaultMessage: "I can",
  },
  alternative2: {
    id: "app.components.AssessmentRubric.alternative2",
    defaultMessage: "Not totally",
  },
  alternative3: {
    id: "app.components.AssessmentRubric.alternative3",
    defaultMessage: "With difficulty",
  },
  alternative4: {
    id: "app.components.AssessmentRubric.alternative4",
    defaultMessage: "I cannot",
  },
  alternativeDefault: {
    id: "app.components.AssessmentRubric.alternativeDefault",
    defaultMessage: " ",
  },
});
